module.exports = __webpack_public_path__ + "static/media/19_tn.dd3c61f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/19_tn.jpg
// module id = 655
// module chunks = 0